import "./App.css";
import Header from "./components/Header";
import VastigruhMahiti from "./components/VastigruhMahiti";
import TeamSection from "./components/TeamSection";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import NewsGallery from "./components/NewsGallery";

function App() {
  return (
    <div>
      <Header />
      <VastigruhMahiti />
      <Gallery />
      <NewsGallery />
      <TeamSection />
      <Footer />
    </div>
  );
}

export default App;
